import React from 'react';
import PropTypes from 'prop-types';
import './BlocoSelector.css';

/**
 * Componente global para seleção de bloco (DUMB)
 * 
 * Responsabilidades do componente:
 * - Renderizar select com blocos pré-filtrados, sem label
 * - Converter string do select para number com parseInt
 * 
 * Responsabilidades da page:
 * - Filtrar blocos conforme feature (blocos com reservatorios, exaustores, etc)
 * - Usar FeatureControlBar para agrupar este componente com título e refresh
 * 
 * @param {Array} blocos - Lista de blocos PRÉ-FILTRADA pela page
 * @param {number|string} selectedBloco - ID do bloco selecionado
 * @param {Function} onBlocoChange - Callback: (blocoId: number) => void
 * @param {boolean} [disabled] - Desabilita select
 */
const BlocoSelector = ({
    blocos,
    selectedBloco,
    onBlocoChange,
    disabled = false
}) => {
    const handleSelectChange = (e) => {
        const blocoId = parseInt(e.target.value);
        onBlocoChange(blocoId);
    };

    // Desabilitar se não tem blocos ou se foi explicitamente passado disabled
    const isDisabled = disabled || blocos.length === 0;

    return (
        <select
            id="bloco-select"
            value={selectedBloco || ''}
            onChange={handleSelectChange}
            disabled={isDisabled}
            className="bloco-selector"
        >
            <option value="" disabled>Selecione um bloco</option>
            {blocos.map((bloco) => (
                <option key={bloco.id} value={bloco.id}>
                    Bloco {bloco.nome}
                </option>
            ))}
        </select>
    );
};

BlocoSelector.propTypes = {
    blocos: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            nome: PropTypes.string.isRequired
        })
    ).isRequired,
    selectedBloco: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    onBlocoChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

export default BlocoSelector;
